import { requestEndpoint } from "./rest-service"
import { WINDOW, getHotlistId } from "../utils/window-utils"
import Utils from "../utils/utilities"
import HotlistStorage from "../decorators/hotlist-storage"
import TrackingService from './tracking-service'

const ERROR_STRING: string = 'There was a problem with the response.'

const errorHandler: Function = (e, reject) => {
    console.error(ERROR_STRING, e)
    reject(e)
}

export default class ListService {

    @HotlistStorage
    private hotlistStorage: any

    public leaveList(): string {
        this.hotlistStorage.lists = this.hotlistStorage.lists.filter(list => list.id !== getHotlistId())

        let newDefaultID: string = ''

        if (Utils.isNotEmpty(this.hotlistStorage.lists)) {
            const listsFirstIndex: any = this.hotlistStorage.lists[0]
            this.hotlistStorage.id = listsFirstIndex.id
            this.hotlistStorage.name = listsFirstIndex.name

            newDefaultID = this.hotlistStorage.id
        } else {
            this.hotlistStorage.id = undefined
            this.hotlistStorage.name = undefined
        }

        return newDefaultID
    }

    public static createNewList(name?: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const listName: string = Utils.isDefined(name) ? name : 'My Wishlist'

            TrackingService.trackEvent('CREATING_NEW_WISHLIST', [listName])

            requestEndpoint(`${WINDOW.nativeWindow.API_GATEWAY_URL}/hotlist`, 'POST', {
                name: listName
            }).then(res => {
                if (Utils.isDefined(res) && Utils.isDefined(res.response) && typeof res.response === 'string') {
                    const responseJSON: any = JSON.parse(res.response)

                    if (Utils.isDefined(responseJSON) && Utils.isDefined(responseJSON.id)) resolve(responseJSON.id)

                    TrackingService.trackEvent('CREATED_NEW_WISHLIST', [responseJSON])
                } else errorHandler(res, reject)
            })
            .catch(e => errorHandler(e, reject))
        })
    }

    public static renameList(name: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            WINDOW.nativeWindow.renaming = true
            requestEndpoint(`${WINDOW.nativeWindow.API_GATEWAY_URL}/hotlist/${getHotlistId()}`, 'PUT', { name })
                .then(() => resolve(name))
                .catch(e => errorHandler(e, reject))
        })
    }

    public static getCurrentList(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            requestEndpoint(`${WINDOW.nativeWindow.API_GATEWAY_URL}/hotlist/${getHotlistId()}`, 'GET').then(res => {
                if (Utils.isDefined(res) && Utils.isDefined(res.response) && typeof res.response === 'string') {
                    const responseJSON: any = JSON.parse(res.response)

                    if (Utils.isDefined(responseJSON)) resolve(responseJSON)

                    TrackingService.trackEvent('GOT_WISHLIST', [responseJSON])
                } else errorHandler(res, reject)
            }).catch(e => errorHandler(e, reject))
        })
    }

    public static removeItem(link: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            WINDOW.nativeWindow.removing = true
            requestEndpoint(link, 'DELETE')
                .then(res => resolve(res))
                .catch(e => reject(e))
        })
    }
}